var exports = {
  "button": "x61f99309--c02315--button",
  "gray": "x61f99309--c02315--gray",
  "red": "x61f99309--c02315--red",
  "blue": "x61f99309--c02315--blue",
  "green": "x61f99309--c02315--green",
};

module.exports = exports;
